import {themeGet} from "@styled-system/theme-get";

export const mergeThemes = (baseTheme: any, customTheme: any) => {
  return {
    ...baseTheme,
    ...customTheme,
    colors: {
      ...baseTheme.colors,
      ...customTheme.colors,
    },
    fontSizes: {
      ...baseTheme.fontSizes,
      ...customTheme.fontSizes,
    },
  };
};
export const getTheme = (query: string, fallback?: string) => {
  return themeGet(query, fallback);
}